export function resolveSearchSource(options: {
  restrictSources?: string | null;
  groups?: string[] | null;
}): 'CURATED' | 'ALL' {
  const isAcademic = Boolean(options.groups?.includes('ROLE_ACADEMIC'));
  return options.restrictSources === 'CURATED' || isAcademic ? 'CURATED' : 'ALL';
}

export function buildAllResultsSearch(source: string): { search: string; title: string } {
  return {
    search: `?view=ALL&idents=ALL&source=${source}&tab=GDA`,
    title: 'All results',
  };
}
